module.exports = __webpack_public_path__ + "img/play-control.876862ba.jpg";